import {
  IApplicationContact,
  IApplicationResident,
} from "@rentiohq/shared-frontend/dist/types/application.types";
import { ELocale } from "@rentiohq/shared-frontend/dist/types/i18n.types";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";

export const getTotalIncome = (contacts: IApplicationContact[]) =>
  contacts.reduce((contactAcc: number, contactCurr: any) => {
    const incomeValue = contactCurr.income.reduce(
      (incomeAcc: number, incomeCurr: any) => incomeAcc + incomeCurr.value,
      0,
    );
    return contactAcc + incomeValue;
  }, 0);

export const getResidentsCount = (
  residents: IApplicationResident[],
  residentId: string,
) => {
  return residents.reduce(
    (currentCount, resident) =>
      resident.id === residentId ? currentCount + resident.value : currentCount,
    0,
  );
};

/**
 * Find common numbers in multiple arrays.
 * @param arrays - Arrays containing numbers.
 * @returns An array containing numbers that appear in each input array.
 */
export const findCommonNumbers = (...arrays: number[][]): number[] => {
  if (arrays.length === 0) {
    return [];
  }

  // Use the first array as a reference
  const referenceArray = arrays[0];

  // Filter numbers that appear in all arrays
  const commonNumbers = referenceArray.filter(num =>
    arrays.every(array => array.includes(num)),
  );

  return commonNumbers;
};

const getLocalizedLangName = (lang: string) => {
  return getLocalizedText(`application.contact_language.${lang}`);
};

export const getLanguage = (locale: string) => {
  switch (locale) {
    case ELocale.NL:
      return getLocalizedLangName("nl");
    case ELocale.FR:
      return getLocalizedLangName("fr");
    case ELocale.EN:
      return getLocalizedLangName("en");
    default:
      return getLocalizedLangName("en");
  }
};
